import React from 'react';
import * as S from './styles';

interface WarningProps extends React.HTMLAttributes<HTMLDivElement> {
  color?: 'orange' | 'gray';
}

const Warning: React.FC<WarningProps> = ({ children, color = 'orange', ...props }) => {
  return (
    <S.Root colorType={color} {...props}>
      {children}
    </S.Root>
  );
};

export default Warning;
